import React from 'react';
import {
  Create,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  TextField,
} from 'react-admin';
import { redirectToReglaTab } from '../regla/regla-utils';

const redirectToReglaEditExcepcionesTab = (basePath, id, data) => redirectToReglaTab(data.idRegla, 'excepciones');

const ExcepcionesCreate = (props) => (
  <Create {...props}>
    <SimpleForm  redirect={redirectToReglaEditExcepcionesTab}>
      <ReferenceField
          source="idRegla"
          reference="regla"
          link="show"
        >
          <TextField source="descripcion"/>
      </ReferenceField>
      <ReferenceInput
        source="idPrestacion"
        reference="prestaciones"
        sort={{ field: "descripcion", order: "ASC" }}
        perPage={100}
        filterToQuery={(searchText) => ({
          descripcion: searchText ? searchText : "",
        })}
        validate={[required()]}
      >
        <AutocompleteInput optionText="descripcion" optionValue="id" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default ExcepcionesCreate;
